const Workflow = () => import('../../../../spa/workflow/Workflow');
const WorkflowList = () => import('../../../../spa/workflow/WorkflowList');
const WorkflowView = () => import('../../../../spa/workflow/WorkflowForm');

export default {
  path: 'workflow',
  component: Workflow,
  children: [
    {
      path: '',
      name: 'workflow',
      component: WorkflowList,
    },
    {
      path: 'novo',
      name: 'novoWorkflow',
      component: WorkflowView,
      props: {
        default: false,
        somenteLeitura: false,
        copia: false,
      },
    },
    {
      path: ':id',
      name: 'verWorkflow',
      component: WorkflowView,
      props: {
        default: true,
        somenteLeitura: true,
        copia: false,
      },
    },
    {
      path: ':id/editar',
      name: 'editarWorkflow',
      component: WorkflowView,
      props: {
        default: true,
        somenteLeitura: false,
        copia: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/workflow.js